import React from "react";
import { Item, MenuSection } from "core/components/hcss-navigation";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { paths } from "../../../../projects/views/paths";
import { Icon } from "hcss-components";
import { strings } from "localization";
import { HeaderSectionWithBackButton } from "../../common/header-section-with-back-button";
import { useFeatureFlags } from "modules/configurationSettings/use-feature-flags";
import { FeatureFlag } from "core";
import { useUserAndCompanyLicense } from "modules/account";

export const CustomizeSetupContext = () => {
  const path = useLocation().pathname;
  const { companyLicense } = useUserAndCompanyLicense();
  const isLimitedCompany = companyLicense.isLimitedLicense;
  const {
    isFeatureEnabled: isFrontEndEmailSubscriptionEnabled
  } = useFeatureFlags(FeatureFlag.FrontEndEmailSubscription);
  return (
    <div
      className="estimate-navigation-context"
      data-testid="customize-setup-context"
    >
      <HeaderSectionWithBackButton backPath="/projects">
        <div>{strings.layout.menu.projectTracking.customize}</div>
      </HeaderSectionWithBackButton>
      <MenuSection>
        {menuStyle => (
          <ItemContainer style={menuStyle}>
            <Item
              data-testid="navitem-estimateAnalysis-estimateDetails"
              key="estimate-details"
              text={strings.projects.list.title}
              isSelected={path === paths.setup}
              to={paths.setup}
            />
            <Item
              data-testid="navitem-estimateAnalysis-keyIndicators"
              key="key-indicators"
              text={strings.projects.setup.heavybidIntegration}
              isSelected={path === paths.setupHBIntegration}
              to={paths.setupHBIntegration}
              after={
                <Icon
                  name="product-heavybid"
                  style={{
                    marginRight: "0.5em",
                    color: "rgb(0, 150, 57)"
                  }}
                />
              }
            />
            {isFrontEndEmailSubscriptionEnabled && (
              <Item
                isLimitedCompany={isLimitedCompany}
                data-testid="navitem-estimateAnalysis-subscription-setup"
                key="subscription-setup"
                text={"Subscription Setup"}
                isSelected={path === paths.subscriptionSetup}
                to={paths.subscriptionSetup}
              />
            )}
          </ItemContainer>
        )}
      </MenuSection>
    </div>
  );
};

const ItemContainer = styled.div`
  font-size: 14px;
  margin-right: 14px;
  color: ${props => props.theme.colors.neutral[0]};
`;
